import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { Footer } from "../../Common/Components/Footer";
import { MaintenanceWrapper } from "../../Common/Components/MaintenanceWrapper";
import { UpperNav } from "../../Common/Components/UpperNav";
import { AppNav } from "./AppNav";

export const Wrapper = () => {
  const loggedIn = useSelector((x) => x.LoggedIn);
  return (
    <>
      <MaintenanceWrapper>
        <UpperNav />
        <AppNav />
        {loggedIn ? (
          <>
            <Outlet />
          </>
        ) : (
          <Navigate to="/admin/auth/login" />
        )}
        <Footer />
      </MaintenanceWrapper>
    </>
  );
};
